import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import logo from "@/assets/logo.png";
import PINKeyboard from "@/components/PINKeyboard";
import { API_URL } from "@/config";

const API = API_URL;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  const handleNumberClick = (num) => {
    if (pin.length < 4) {
      const newPin = pin + num;
      setPin(newPin);
      
      // Auto-verify when 4 digits entered
      if (newPin.length === 4) {
        handleLogin(newPin);
      }
    }
  };

  const handleBackspace = () => {
    setPin(pin.slice(0, -1));
  };

  const handleClear = () => {
    setPin("");
  };

  const handleLogin = async (pinToVerify) => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/admin/login-pin`, {
        pin: pinToVerify
      });

      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminEmail", response.data.email);
      
      toast.success("Login successful!");
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Invalid PIN");
      setPin("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card max-w-md w-full p-8">
        <div className="flex flex-col items-center mb-8">
          <img src={logo} alt="Logo" className="logo mb-4" />
          <h1 className="text-3xl font-bold mb-2">Admin Login</h1>
          <p className="text-white/70 text-center">Enter 4-digit PIN to access admin panel</p>
        </div>

        {/* PIN Display */}
        <div className="flex justify-center gap-3 mb-6">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`w-14 h-14 rounded-lg border-2 flex items-center justify-center text-2xl font-bold ${
                pin.length > i
                  ? 'border-[#ff3131] bg-[#ff3131]/20'
                  : 'border-white/30 bg-white/5'
              }`}
            >
              {pin.length > i ? '•' : ''}
            </div>
          ))}
        </div>

        {/* Custom Keyboard */}
        <PINKeyboard
          onNumberClick={handleNumberClick}
          onBackspace={handleBackspace}
          onClear={handleClear}
        />

        {loading && (
          <p className="text-center mt-4 text-white/70">Verifying...</p>
        )}
      </div>
    </div>
  );
}
